import MandalaBackground from "@/components/MandalaBackground";

export default function DifferentiationScene() {
  return (
    <section
      className="home-band relative px-5 sm:px-8"
      style={{ background: "hsl(var(--ink))" }}
    >
      <MandalaBackground opacity={0.04} withRadialLight={false} />

      <div className="relative z-10 max-w-4xl mx-auto w-full text-left">
        <p className="scroll-reveal section-eyebrow">What makes this different</p>

        <h2 className="scroll-reveal section-heading mt-3">
          Not therapy.
          <br />
          Not astrology.
          <br />
          <span className="italic" style={{ color: "hsl(var(--marigold))" }}>
            Not generic advice.
          </span>
        </h2>

        <div
          className="scroll-reveal mt-8 max-w-xl space-y-3 text-manuscript/65"
          style={{ fontSize: "clamp(0.9rem, 1.15vw, 1.05rem)", lineHeight: 1.6 }}
        >
          <p>Most products tell you what might happen.</p>
          <p>Outspoken helps you understand what to do.</p>
          <p className="italic text-manuscript/80">That difference matters — because people don't just want comfort, they want a decision they can live with.</p>
        </div>
      </div>
    </section>
  );
}
